import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, mergeProps as _mergeProps, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, unref as _unref, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "folder-content content-panel" }
const _hoisted_2 = { class: "sessions-panel" }
const _hoisted_3 = {
  role: "region",
  title: "Folder Title",
  "aria-label": "Folder Title",
  class: "header"
}
const _hoisted_4 = ["href", "onClick"]
const _hoisted_5 = {
  key: 1,
  class: "p-breadcrumb-item-text"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  role: "region",
  title: "Folder Contents"
}
const _hoisted_8 = {
  key: 0,
  class: "subheader"
}

import { ref, computed, useTemplateRef, onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import { previousRoute } from "@/router";
import BaseView from "../views/BaseView.vue";
import ItemList from "../components/Home/ItemList.vue";
import TitleChangeModal from "../components/TitleChangeModal.vue";
import MoveSessionModal from "../components/MoveSessionModal.vue";
import RequestNotesOrderForm from "../components/Orders/RequestNotesOrderForm.vue";
import RowActionMenubar from "../components/Home/RowActionMenubar.vue";
import { SessionWithOrdersAndType } from "@/types/session-interfaces";
import { OrderForm } from "@/types/order-interfaces";
import { ItemListColumn, ItemListMenuProp } from "@/types/itemlist-interfaces";
import { useTitleChangeModal } from "@/composables/useTitleChangeModal";
import { useOrderForm } from '@/composables/useOrderForm'
import { useRowActionVisibility } from "@/composables/useRowActionMenubar";
import { useSupplementaryUpload } from "@/composables/useSupplementaryUpload";
import pencilWhite from "@/assets/images/Pencil-white.svg";


export default /*@__PURE__*/_defineComponent({
  __name: 'Folder',
  setup(__props) {

const { triggerFileUpload } = useSupplementaryUpload();

const {
orderFormVisible,
sessionTitle,
durationHMS,
durationMilliseconds,
recordingUploadId,
requestNotes,
setOrderFormVisible,
} = useOrderForm();

const {
titleChangeModalVisible,
selectedTitle,
selectedId,
openTitleChangeModal,
setTitleChangeModal,
} = useTitleChangeModal();

const { rowActionVisible } = useRowActionVisibility();

const route = useRoute(),
    router = useRouter(),
    store = useStore();

const loader = ref<boolean>(false),
    folderTitle = ref<string>(""),
    isDataLoaded = ref<boolean>(false),
    isArchived = ref<boolean>(false),
    moveSessionModal = ref();

const orderForm = useTemplateRef<OrderForm>("orderForm"),
    folderItemList = useTemplateRef<typeof ItemList>("folderItemList"),
    moveSessionModalRef = useTemplateRef("moveSessionModalFolder");

const home = computed(() => {
if (previousRoute.value && 
    typeof previousRoute.value === 'object' && 
    'name' in previousRoute.value && 
    'path' in previousRoute.value) {
  return {
    label: previousRoute.value['name'],
    route: previousRoute.value['path'],
  };
} else {
  return {
    label: 'Home',
    route: '/home'
  };
}
});

const folders = computed(()  => [
{ label: folderTitle.value || route.query.title || 'Folder' },
]);

const columns = computed<ItemListColumn[]>(() => [
{  
  field: "title",
  header: "TITLE",
  sortable: true, 
  width: isArchived.value ? "30.44%" : "40.44%",
},
{
  field: "noteStatus",
  header: "NOTES STATUS",
  sortable: true,
  width: "14.58%",
},
{
  field: "uploads",
  sortable: true,
  sortFunction: (
    session1: SessionWithOrdersAndType,
    session2: SessionWithOrdersAndType
  ) => {
    const uploads1 = session1.uploads || [];
    const uploads2 = session2.uploads || [];
    return uploads1.length - uploads2.length;
  },
  header: "SUPPLEMENTARY FILES",
  width: "18.75%",
},
{
  field: "createdAt",
  header: "CREATED",
  sortable: true,
  width: "17.36%",
},
{
  field: "num",
  header: "", 
  icon: true, 
  width: isArchived.value ? "18.86%" : "4.86%",
},
]);

const sessionMenuProps = [
{
  label: "Open",
  icon: "itemlist-open-svg-icon",
  command: (rowData: SessionWithOrdersAndType) => {
    open(rowData);
  },
},
{
  label: "Request Professional Note",
  command: (rowData: SessionWithOrdersAndType) => {
    requestNotes(rowData);
  },
  icon: "itemlist-requestnotes-svg-icon",
  checkLabel: (rowData: SessionWithOrdersAndType) => {
    return rowData.noteStatus !== "no-value"
      ? "Notes Requested"
      : "Request Professional Notes";
  },
  checkVisible: (rowData: SessionWithOrdersAndType) => {
    return (
      !(
        rowData.uploads &&
        rowData.uploads[0] &&
        rowData.uploads[0].type === "mp-document"
      ) &&
      !(
        rowData.uploads &&
        rowData.uploads[0] &&
        rowData.uploads[0].type === "mp-instant-session"
      ) &&
      hasProNoteAccess.value
    );
  },
  checkDisable: (rowData: SessionWithOrdersAndType) => {
    return rowData.noteStatus !== "no-value";
  },
},
{
  label: "Add Supplementary Material",
  command: (rowData: SessionWithOrdersAndType) => {
    triggerFileUpload(rowData.id);
  },
  checkDisable: (rowData: SessionWithOrdersAndType) => { return rowData.uploads && rowData.uploads.filter((upload: any) => upload.type === "mp-supplementary").length > 4; },
  icon: "itemlist-upload-white-svg-icon",
},
{
  label: "Copy Session ID",
  command: (rowData: SessionWithOrdersAndType) => {
    copySessionId(rowData.id);
  },
  icon: "itemlist-copy-svg-icon",
},
{
  label: "Rename",
  icon: "itemlist-rename-svg-icon",
  command: (rowData: SessionWithOrdersAndType) => {
    console.log("[DEBUG]: TODO: OPEN RENAME MODAL HERE");
      openTitleChangeModal({id: rowData.id, title: rowData.title, type: "session"});
  },
},
];

const hasProNoteAccess = computed(() => {
  return store.getters['user/hasProNotesEnabled'];
});

const folderMenuProps: ItemListMenuProp[] = [];


function open(data: SessionWithOrdersAndType) {
store.commit("user/setSessionDetails", data);
router.push({
  name: "SessionInitializer",
});
}

function copySessionId(e: string) {
try {
  navigator.clipboard.writeText(e);
} catch (error) {
  console.log(error);
}
}

function clearOrderFormValues() {
if (
  orderForm.value &&
  orderForm.value.orderSubmitted &&
  orderForm.value.step &&
  orderForm.value.orderSubmissionErrorMessage
) {
  orderForm.value.orderSubmitted = false;
  orderForm.value.step = 0;
  orderForm.value.orderSubmissionErrorMessage = "";
}
}

// Computed properties
const folderId = computed(() => 
route.params.folderId as string
)

const folderIndex = computed(() => 
store.getters['itemList/getFolderIndexById'](route.params.folderId, 
  isArchived.value ? 'archivedItems' : 'allFolders'
)
)

const currentFolder = computed(() => {
if (folderIndex.value !== -1) {
  if (!isArchived.value){
    return store.state.itemList.allFolders[folderIndex.value] 
  }
  else {
    return store.state.itemList.archivedItems[folderIndex.value]
  }
}
else {
  return null
}
})

const tableData = computed(() => 
currentFolder.value?.sessions || []
)

const openMoveSessionModal = async () => {
await moveSessionModal.value?.show();
};

function updateTitle(title: string) {
folderTitle.value = title;
}

const initPageData = async  () => {
  if (currentFolder.value) {
    if (isArchived.value){
      await store.dispatch('itemList/loadAndProcessFolder', {folderId: folderId.value, array: 'archivedItems'})
    }
    else {
      await store.dispatch('itemList/loadAndProcessFolder', {folderId: folderId.value, array: 'allFolders'})
    }
    isDataLoaded.value = true
  } 
}

onMounted(async () => {
loader.value = true;
// folderId.value = route.params.folderId as string;
// folderTitle.value = route.query.title as string;
isArchived.value = route.query.isArchived === "true";

updateTitle(route.query.title as string || "Folder");

if (currentFolder.value) {
  if (isArchived.value){
    await store.dispatch('itemList/loadAndProcessFolder', {folderId: folderId.value, array: 'archivedItems'})
  }
  else {
    await store.dispatch('itemList/loadAndProcessFolder', {folderId: folderId.value, array: 'allFolders'})
  }
  isDataLoaded.value = true
} 
moveSessionModal.value = moveSessionModalRef.value;
loader.value = false;
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BaseView, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("section", _hoisted_3, [
              _createVNode(_component_Breadcrumb, {
                home: home.value,
                model: folders.value
              }, {
                item: _withCtx(({ item, props }) => [
                  (item.route)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: item.route,
                        custom: ""
                      }, {
                        default: _withCtx(({ href, navigate }) => [
                          _createElementVNode("a", _mergeProps({ href: href }, props.action, { onClick: navigate }), _toDisplayString(item.label), 17, _hoisted_4)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(item.label), 1))
                ]),
                _: 1
              }, 8, ["home", "model"]),
              (!isArchived.value)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    variant: "text",
                    class: "edit-folder-title-button",
                    severity: "danger",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(openTitleChangeModal)({ id: folderId.value, title: folderTitle.value, type: 'folder' }))),
                    onKeydown: _cache[1] || (_cache[1] = ($event) => {
                if ($event.key === 'Enter') {
                  $event.preventDefault();
                  _unref(openTitleChangeModal)({ id: folderId.value, title: folderTitle.value, type: 'folder' });
                }
              }),
                    "aria-label": "Edit title"
                  }, {
                    icon: _withCtx(() => [
                      _createElementVNode("img", {
                        role: "presentation",
                        src: _unref(pencilWhite),
                        alt: "Edit title",
                        class: "edit-folder-title-icon"
                      }, null, 8, _hoisted_6)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("section", _hoisted_7, [
              (tableData.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, " This folder is currently empty. "))
                : (tableData.value.length > 0 && isDataLoaded.value)
                  ? (_openBlock(), _createBlock(ItemList, {
                      key: 1,
                      ref_key: "folderItemList",
                      ref: folderItemList,
                      data: tableData.value,
                      columns: columns.value,
                      loader: loader.value,
                      sessionMenuProps: sessionMenuProps,
                      folderMenuProps: folderMenuProps,
                      openSession: open,
                      isArchive: isArchived.value,
                      scrollHeight: '100vh',
                      lazyLoading: false,
                      storageKey: `folder-table-${folderId.value}`
                    }, null, 8, ["data", "columns", "loader", "isArchive", "storageKey"]))
                  : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(RequestNotesOrderForm, {
      visible: _unref(orderFormVisible),
      recordingTitle: _unref(sessionTitle),
      durationHMS: _unref(durationHMS),
      durationMilliseconds: _unref(durationMilliseconds),
      recordingUploadId: _unref(recordingUploadId),
      setOrderFormVisible: _unref(setOrderFormVisible),
      onHide: clearOrderFormValues,
      ref_key: "orderForm",
      ref: orderForm
    }, null, 8, ["visible", "recordingTitle", "durationHMS", "durationMilliseconds", "recordingUploadId", "setOrderFormVisible"]),
    _createVNode(TitleChangeModal, {
      itemId: _unref(selectedId),
      itemTitle: _unref(selectedTitle),
      itemType: 'folder',
      visible: _unref(titleChangeModalVisible),
      setVisible: _unref(setTitleChangeModal),
      onUpdateTitleSuccessful: updateTitle
    }, null, 8, ["itemId", "itemTitle", "visible", "setVisible"]),
    _createVNode(MoveSessionModal, {
      ref: "moveSessionModalFolder",
      onReloadPage: initPageData
    }, null, 512),
    (folderItemList.value)
      ? (_openBlock(), _createBlock(RowActionMenubar, {
          key: 0,
          toggleSessionMenu: folderItemList.value?.toggleSessionMenu,
          visible: _unref(rowActionVisible),
          onRenameItem: _unref(openTitleChangeModal),
          onMoveItem: openMoveSessionModal
        }, null, 8, ["toggleSessionMenu", "visible", "onRenameItem"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})